import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { ApplicationState } from '../../data/applicationStates';
import { headerActionCreators } from '../../data/header/headerActions';
import { HeaderState } from '../../data/header/headerModels';
import { invoicesActionCreators } from '../../data/invoices/invoicesAction';
import { ApiInvoicesState } from '../../data/invoices/invoicesModels';
// tslint:disable-next-line:no-var-requires
const invoices = require('../../resources/invoices.png');
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { projectsActionCreators } from '../../data/projects/projectsAction';
import { ProjectsState } from '../../data/projects/projectsModels';

/* tslint:disable */
type DesignProjectProps = DesignProjectState & // ... state we've requested from the Redux store
    DesignProjectActions & // ... plus action creators we've requested
    RouteComponentProps<{ id: string }>;

interface DesignProjectState {
    projects: ProjectsState;
    header: HeaderState;
    invoices: ApiInvoicesState;
}

interface DesignProjectActions {
    projectsAction: typeof projectsActionCreators;
    headerActions: typeof headerActionCreators;
    invoicesActions: typeof invoicesActionCreators;
}

interface State {
    name?: string;
    estCompletionDate?: string;
    status?: string;
    projectNumber?: string;
}

class DesignProject extends React.Component<DesignProjectProps, State> {
    constructor(props: DesignProjectProps) {
        super(props);
        this.state = {
            name: undefined,
            estCompletionDate: undefined,
            status: undefined,
            projectNumber: undefined
        };
        this.getTheProject = this.getTheProject.bind(this);
    }

    getTheProject(id: string) {
        if (this.props.projects.projects.length > 0) {
            this.props.projects.projects.filter((project) => {
                if (project.projectNumber === id) {
                    this.setState({
                        name: project.name,
                        estCompletionDate: moment(project.estCompletionDate).format('L'),
                        status: project.projectStatus,
                        projectNumber: project.projectNumber
                    });
                }
            });
        }
    }

    componentWillMount() {
        this.getTheProject(this.props.match.params.id);
    }

    public render() {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="componentHeader">
                        <div className="item tile">
                            <div className="tileHead">
                                <div className="float-left">
                                    <h4>{'Design Project'}</h4>
                                </div>
                                <div className="tileImage float-right">{<img src={invoices} />}</div>
                            </div>
                            <div className="tileBody">
                                <div className="topBorder" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="bold">Name:</div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div>{this.state.name ? this.state.name : ''}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="bold">Est. Completion Date:</div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div>
                                            {this.state.estCompletionDate
                                                ? moment(this.state.estCompletionDate).format('M/D/YYYY')
                                                : ''}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="bold">Status:</div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div>{this.state.status ? this.state.status : ''}</div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="bold">Project Number:</div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div>{this.state.projectNumber ? this.state.projectNumber : ''}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state: ApplicationState): DesignProjectState {
    return {
        header: state.header,
        invoices: state.invoices,
        projects: state.projects
    };
}

function mapDispatchToProps(dispatch: Dispatch<{}>): DesignProjectActions {
    return {
        projectsAction: bindActionCreators(projectsActionCreators, dispatch),
        headerActions: bindActionCreators(headerActionCreators, dispatch),
        invoicesActions: bindActionCreators(invoicesActionCreators, dispatch)
    };
}

export default withRouter(
    connect(
        mapStateToProps, // Selects which state properties are merged into the component's props
        mapDispatchToProps // Selects which action creators are merged into the component's props
    )(DesignProject)
);



// WEBPACK FOOTER //
// ./src/containers/designProject/designProject.tsx